import React from 'react'
import Link from 'gatsby-link'
import injectSheet from 'react-jss'
import classNames from 'classnames'

import JDlogo from '../images/JDeveaux-logo.svg'
import preLoader from '../images/Loader.png'

import { styles } from '../Styles/index.Style'

type State = {
  isLoaded: boolean
}

type Props = {
  classes: { [string]: string }
}

class IndexPage extends React.Component {
  props: Props
  state: State

  constructor (props: Props) {
    super(props)
    this.state = {
      isLoaded: false
    }
  }

  componentDidMount () {
    this.setState({isLoaded: true})
  }

  render () {
    const {classes} = this.props
    const {isLoaded} = this.state
    return (
      isLoaded
      ?
      <div className={classNames('row', classes.paddingRight0)}>
        <div className={classNames('col-sm-6 col-xs-10 col-xs-offset-1', classes.container)}>
          <div className={classes.mainContent}>
            <img src={JDlogo} className='hideMDDown' />
              <p><strong>Julien Deveaux</strong>, Entrepreneur, Product Designer, Teacher and Mentor crafting products with tech companies in Europe, Silicon Valley, New York and Latin America.</p>
            <div>
              <Link
                to='/contact'
                className={classes.button}>
                Get in touch
              </Link>
              <Link
                to='/work'
                className={classes.link}>
                View past projects
              </Link>
            </div>
          </div>
          <div className={classes.notes}>
            <Link
              to='/contact'
              className={classNames(classes.borderTop, classes.linkParagraph, classes.available)}>
              <p><strong>Available</strong> for some freelance work, send me a note and we will start from there.</p>
            </Link>
            <div className={classNames(classes.borderTop, classes.socialMedias)}>
              <p>Find out more on social medias:</p>
              <a href='https://medium.com/@juliendeveaux'>
                <i className='icn-medium'></i>
              </a>
              <a href='https://dribbble.com/JulienDeveaux'>
                <i className='icn-dribbble'></i>
              </a>
              <a href='https://www.linkedin.com/in/juliendeveaux/'>
                <i className='icn-linkedin'></i>
              </a>
            </div>
          </div>
        </div>
        <canvas className={classNames('col-xs-4 col-xs-offset-1 hideMDDown', classes.canvas)}>
        </canvas>
      </div>
      :
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh'
      }}>
        <div className='containerAdjustMobile' style={{
          position: 'relative'
        }}>
          <div style={{
            width: 120,
            height: 120,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px solid #f3f3f3',
            borderTop: '3px solid #000',
            borderRadius: '100%',
            animationName: 'spin',
            animationDuration: '1s',
            animationTimingFunction: 'linear',
            animationIterationCount: 'infinite'
          }} />
          <img
            src={preLoader}
            alt='laoding'
            style={{
              width: 60,
              position: 'absolute',
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              margin: 'auto'
          }} />
        </div>
      </div>
    )
  }
}

export default injectSheet(styles)(IndexPage)



// WEBPACK FOOTER //
// ./src/pages/index.js